import React, { useContext, useEffect, createContext } from 'react';

// project-imports
import { showToast } from '../components/sweet-alert/Sweetalert';
import { GET_QUICK_INSIGHTS_BEGIN, GET_QUICK_INSIGHTS_FAILURE, GET_QUICK_INSIGHTS_SUCCESS, GET_USER_INTERACTION_BY_INSIGHTS_BEGIN, GET_USER_INTERACTION_BY_INSIGHTS_SUCCESS, GET_USER_INTERACTION_BY_INSIGHTS_FAILURE, UPSERT_QUICK_INSIGHTS_USER_INTERACTION_BEGIN, UPSERT_QUICK_INSIGHTS_USER_INTERACTION_SUCCESS, UPSERT_QUICK_INSIGHTS_USER_INTERACTION_FAILURE, GET_ALL_INSIGHTS_USER_INTERACTION_FAILURE, GET_ALL_INSIGHTS_USER_INTERACTION_SUCCESS, GET_ALL_INSIGHTS_USER_INTERACTION_BEGIN } from '../constants/actions';
import { fetchData, postData, updateData } from './salesforce_api_context';
import blogdata from '../data/blog/PostData.json'
import { useBugContext } from './bug_context';
import { useUserContext } from './user_context';
import { getOrCreateGuestId } from '../utils';

// third-party
import { useDispatch, useSelector } from "react-redux";

// Create context
export const QuickInsightContext = createContext();

export const QuickInsightProvider = (props) => {

    // Reading store date
    const insightsData = useSelector(state => state.quickInsights);

    const { bugReportApi } = useBugContext();

    // Reading dispatch from Store
    const dispatch = useDispatch();

    // Constant functions

    // Function to get all blogs
    const fetchQuickInsights = async () => {
        try {
            // Dispatching the action to begin  the api calling process
            dispatch({ type: GET_QUICK_INSIGHTS_BEGIN, payload: true });

            // Calling API to get blogs 
            let response = await fetchData(`/api/quick-insight`);
            // let response = blogdata;

            // Dispatching the actions on success
            dispatch({ type: GET_QUICK_INSIGHTS_SUCCESS, payload: response });

        } catch (error) {
            console.log("42 : quick_insight_context : Error while fetching quick-insights::", error && JSON.stringify(error));

            // Dispatching the actions on error
            dispatch({ type: GET_QUICK_INSIGHTS_FAILURE, payload: error && error.message });

            bugReportApi("Error while fetching quick-insights", `/api/quick-insight`, "GET", error);

            // Showing the toast message on getting blogs unsuccessfully 
            showToast("error", (error && error.message) ? "We are unable to get the quick insights!" : "An error occurred", true, "bottom-right", false, true, 5000);

        }
    }

    // Send user-interaction
    const upsertInsightsUserInteraction = async (body) => {
        try {
            // Dispatching the action to begin the api calling process
            dispatch({ type: UPSERT_QUICK_INSIGHTS_USER_INTERACTION_BEGIN, payload: true });

            // Api calling for postData
            let response = await postData("/api/quick-insight-interaction", body);

            // Dispatching the actions on success
            dispatch({ type: UPSERT_QUICK_INSIGHTS_USER_INTERACTION_SUCCESS, payload: response });

        } catch (error) {
            console.log(
                "64 : quick_insight_context : Error while upserting insights user-interaction data::",
                error && JSON.stringify(error),
            );

            // Dispatching the actions on error
            dispatch({
                type: UPSERT_QUICK_INSIGHTS_USER_INTERACTION_FAILURE,
                payload: error && error.message,
            });

            bugReportApi("Error while upserting quick-insights user interaction", `/api/quick-insight-interaction`, "POST", error);
        }
    };

    const getAllQuickInsightsInteraction = async () => {
        try {
            // Dispatching the action to begin the api calling process
            dispatch({ type: GET_ALL_INSIGHTS_USER_INTERACTION_BEGIN, payload: true });

            // Calling API to get data
            let response = await fetchData(
                `/api/quick-insight-interaction`,
            );

            // Dispatching the actions on success
            dispatch({ type: GET_ALL_INSIGHTS_USER_INTERACTION_SUCCESS, payload: response });

            // Showing the toast message on getting instructor data successfully
            // showToast("success", "Getting instructor details successfully ", true, "bottom-right", false, true, 5000);
        } catch (error) {
            console.log(
                "125 : quick_insight_context : Error while getting  user-interaction by insights data::",
                error && JSON.stringify(error),
            );

            // Dispatching the actions on error
            dispatch({
                type: GET_ALL_INSIGHTS_USER_INTERACTION_FAILURE,
                payload: error && error.message,
            });

            bugReportApi("Error while getting all quick-insights user interaction", `/api/quick-insight-interaction`, "GET", error);
        }
    };

    useEffect(() => {
        fetchQuickInsights();
        getAllQuickInsightsInteraction();
    }, []);

    return (
        <QuickInsightContext.Provider value={{ ...insightsData, upsertInsightsUserInteraction }}>
            {props.children}
        </QuickInsightContext.Provider>
    )
}
export const useQuickInsightContext = () => {
    return useContext(QuickInsightContext)
}
